// import from react library
import { useState } from "react";

// main component imports
import {Label, SearchIcon} from "Component";

// style imports and local component imports
import './IconList.css';
import IconCard from "./IconCard";

const IconList = ({value, onClick, maxHeight}) => {
  // set state from search
  const [search, setSearch] = useState("")
  return (
    <div className='icon_container input_field'>
      <div className='mues_row_space_between input_field'>
          <Label>Select icon</Label>
          <SearchIcon search={search} setSearch={setSearch}/>
      </div>
      <div className='icon_list_container' style={{maxHeight:maxHeight}}>
          <IconCard value={value} onClick={e=>onClick(e)}
          search={search}/>
      </div>
    </div>
  )
}

export default IconList